// plugins 
import {gmapApi} from 'vue2-google-maps'

export const gmapmixins = {
    data() {
        return {
            svgMarker : null
        }
    },
    computed: {
        google: gmapApi
    },
    methods : {
        /**
         * Autocomplete address with dropdown suggestion
         * @param {DOM} element 
         * @param {Function} callback
         */
        autocompletedress(element, callback) {
            if(this.google) {
                console.log('google map autocomplete inititated');
                const bound = new this.google.maps.LatLngBounds(
                    new this.google.maps.LatLng(40.76072578643754, -111.89679763140082),
                );
                

                const options = {
                    bounds               : bound,
                    componentRestrictions: { country: "us" },
                    fields               : ["address_components", "geometry", "icon", "name"],
                    strictBounds         : false,
                    radius               : 20000
                };
                  
                let service = new this.google.maps.places.Autocomplete(element, options);

                service.addListener('place_changed', () => {
                    const place = service.getPlace();
                    if(callback && typeof callback == 'function') {
                        callback(place)
                    }
                });

            }
        },
       /**
        * Search places from google map api
        * @param {DOM} element 
        * @param {String} querystring 
        */
        async queryPlace(element, querystring = '') {
            if(this.google) {
                let service = new this.google.maps.places.PlacesService(element);

                const newpromise = new Promise((resolve) => {

                    let search_query = {
                        fields : ['formatted_address', 'geometry', 'place_id', 'types'],
                        query : querystring
                    };
    
                    service.findPlaceFromQuery(search_query, res => {
                        resolve(res);
                    })
                });

                return newpromise;

            }
        },
        /**
         * Initiate google map service
         */
        initMap() {
            if(this.google) {
                this.$nextTick(() => {
                    this.svgMarker = {
                        path        : "M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z",
                        fillColor   : "#A32035",
                        fillOpacity : 1,
                        strokeWeight: 0,
                        rotation    : 0,
                        scale       : 1.5,
                        anchor      : new this.google.maps.Point(0, 10),
                    }
                });
            } 
        }
    }
}